<template>
  <div class="msgtypeVideo">
    <video class="box_video" controls="controls">
      <source :src="items.cos_file_url" />
    </video>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.msgtypeVideo {
  width: 256px;
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  .box_video {
    width: 100%;
    border-radius: 8px;
  }
}
</style>
